<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">Статистика</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12 lg12 md12>

        <p class="title">Статистика по каналам продаж</p>
        <v-layout class="elevation-1 white mb-4 pa-3 column">
          <v-flex xs12 lg12 md12>
            <v-layout>
              <v-flex xs4 lg4 md4>
                <v-menu
                    ref="distributionChannelStatisticsStartDateMenu"
                    :close-on-content-click="false"
                    v-model="distributionChannelStatistics.startDateMenu"
                    :return-value.sync="distributionChannelStatistics.startDate"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    class="mr-3"
                >
                  <v-text-field
                      slot="activator"
                      v-model="distributionChannelStatistics.startDateFormatted"
                      label="Начальная дата"
                      readonly
                      outline
                  ></v-text-field>
                  <v-date-picker
                      v-model="distributionChannelStatistics.startDate"
                      locale="ru"
                      :first-day-of-week="1"
                      @input="onInputStartDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs4 lg4 md4>
                <v-menu
                    ref="distributionChannelStatisticsEndDateMenu"
                    :close-on-content-click="false"
                    v-model="distributionChannelStatistics.endDateMenu"
                    :return-value.sync="distributionChannelStatistics.endDate"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                    class="mr-3"
                >
                  <v-text-field
                      slot="activator"
                      v-model="distributionChannelStatistics.endDateFormatted"
                      label="Конечная дата"
                      readonly
                      outline
                  ></v-text-field>
                  <v-date-picker
                      v-model="distributionChannelStatistics.endDate"
                      locale="ru"
                      :first-day-of-week="1"
                      @input="onInputEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs4 lg4 md4>
                <v-select
                    :items="groupList"
                    label="Группировка"
                    outline
                    v-model="distributionChannelStatistics.group"
                    @input="getDistributionChannelChartData"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12>
            <v-layout row>
              <v-flex xs12 lg12 md12>
                <v-combobox
                    :items="[]"
                    v-model="distributionChannelStatistics.branchesSelected"
                    label="Филиалы"
                    chips
                    outline
                    multiple
                    readonly
                    @click="distributionChannelStatistics.branchesDialog = true"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                        @click="distributionChannelStatistics.branchesDialog = true"
                    >
                      <strong>{{ data.item }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12>
            <v-layout>
              <v-flex xs12 lg12 md12>
                <v-combobox
                    v-model="distributionChannelStatistics.productItems"
                    :items="[]"
                    label="Товары"
                    chips
                    outline
                    multiple
                    readonly
                    @click="distributionChannelStatistics.productDialog = true"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                        :selected="data.selected"
                        :color="data.item.color"
                        @click="distributionChannelStatistics.productDialog = true"
                    >
                      <strong>{{ data.item.title }}</strong>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 lg12 md12 class="mt-3">
            <v-layout>
              <v-flex xs12 lg12 md12>
                <line-chart :data="distributionChannelStatistics.chartData" :library="chartOptions"></line-chart>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-dialog
              v-model="distributionChannelStatistics.branchesDialog"
              max-width="600"
          >
            <v-card>
              <v-card-title class="headline">Филиалы</v-card-title>
              <v-layout row>
                <v-flex xs12 lg12 md12 class="ml-2">
                  <div
                      v-for="(branch, index) in distributionChannelStatistics.branches"
                      :key="branch.id"
                  >
                    <v-checkbox
                        :label="branch.title"
                        class="ma-0 pa-0"
                        v-model="distributionChannelStatistics.branches[index].checked"
                        @change="onBranchInput"
                    ></v-checkbox>
                  </div>
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="distributionChannelStatistics.branchesDialog = false">ОК</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
              v-model="distributionChannelStatistics.productDialog"
              max-width="600"
          >
            <v-card>
              <v-card-title class="headline">Товары</v-card-title>
              <v-layout row v-if="distributionChannelStatistics.productTreeData.length > 0" class="mt-4">
                <v-flex xs12 lg12 md12 class="ml-2">
                  <tree
                      ref="distributionChannelStatisticsTree"
                      :data="distributionChannelStatistics.productTreeData"
                      :options="{
                      checkbox: true,
                        fetchData(node) {
                          if (node.data.type === 'category') {
                            return getProductBrand(node.data.id)
                          } else if (node.data.type === 'brand') {
                            return getProductSku(node.data.id)
                          }
                        }
                      }"
                      class="tree--small"
                      @node:checked="productItemsUpdate"
                      @node:unchecked="productItemsUpdate"
                  />
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="distributionChannelStatistics.productDialog = false">ОК</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Статистика'}
        ],
        pageDataReady: {
          isReady: false
        },
        groupList: [{text: 'День', value: 'day'}, {text: 'Неделя', value: 'week'}, {text: 'Месяц', value: 'month'}],
        channelList: [],
        productTreeIdCounter: 0,
        distributionChannelStatistics: {
          startDate: null,
          startDateFormatted: null,
          startDateMenu: false,
          endDate: null,
          endDateFormatted: null,
          endDateMenu: false,
          group: 'day',
          productDialog: false,
          productCategoryIdList: [],
          productBrandIdList: [],
          productSkuList: [],
          productTreeData: [],
          productItems: [],
          chartData: [],
          branches: [],
          branchesSelected: [],
          branchesDialog: false
        },
        chartOptions: {
          tooltips: {
            mode: 'index',
            displayColors: true,
            callbacks: {
              label: function (tooltipItem) {
                let val = tooltipItem.yLabel
                val = Math.round(parseFloat(val)).toString()
                let result = ''
                let i = 0
                val.split('').reverse().forEach(function (char) {
                  if (i === 3) {
                    result += ' '
                    i = 1
                  } else {
                    i++
                  }
                  result += char
                })
                result = result.split('').reverse().join('')
                return result + ' ₽'
              }
            }
          }
        }
      }
    },
    beforeCreate () {
      this.$store.commit('setPageLoading', true)
    },
    created () {
      this.pageDataStatus()
      this.$store.commit('setPageTitle', 'Статистика по каналам продаж')
      this.getProductCategory('distributionChannelStatistics')
        .then((data) => {
          this.distributionChannelStatistics.productTreeData = data
        })
        .catch((e) => {
          console.log(e)
        })

      let date = new Date()
      this.distributionChannelStatistics.endDate = this.$moment(date).format('YYYY-MM-DD')
      date.setDate(date.getDate() - 30)
      this.distributionChannelStatistics.startDate = this.$moment(date).format('YYYY-MM-DD')
      this.distributionChannelStatistics.startDateFormatted = this.formatDate(this.distributionChannelStatistics.startDate)
      this.distributionChannelStatistics.endDateFormatted = this.formatDate(this.distributionChannelStatistics.endDate)
      this.getDistributionChannelChartData()

      this.$store.dispatch('getBranchList')
    },
    computed: {
      distributionChannelChartData () {
        return this.$store.getters.distributionChannelChartData
      },
      distributionChannelStatisticsProductDialog () {
        return this.distributionChannelStatistics.productDialog
      },
      branchList () {
        return this.$store.getters.branchList
      }
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}.${month}.${year}`
      },
      pageDataStatus () {
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      getDistributionChannelChartData () {
        let filtersData = {
          start_date: this.distributionChannelStatistics.startDate,
          end_date: this.distributionChannelStatistics.endDate,
          group: this.distributionChannelStatistics.group
        }

        if (this.distributionChannelStatistics.productCategoryIdList.length > 0 || this.distributionChannelStatistics.productBrandIdList.length > 0 || this.distributionChannelStatistics.productSkuList.length > 0) {
          this.filterChildrenProductIdList(this.$refs.distributionChannelStatisticsTree.model, this.distributionChannelStatistics)
          if (this.distributionChannelStatistics.productCategoryIdList.length > 0) {
            filtersData.product_category_id_list = this.distributionChannelStatistics.productCategoryIdList
          }
          if (this.distributionChannelStatistics.productBrandIdList.length > 0) {
            filtersData.product_brand_id_list = this.distributionChannelStatistics.productBrandIdList
          }
          if (this.distributionChannelStatistics.productSkuList.length > 0) {
            filtersData.product_sku_id_list = this.distributionChannelStatistics.productSkuList
          }
        }

        let branchIdList = []
        for (let i = 0; i < this.distributionChannelStatistics.branches.length; i++) {
          if (this.distributionChannelStatistics.branches[i].checked) {
            branchIdList.push(this.distributionChannelStatistics.branches[i].id)
          }
        }
        if (branchIdList.length > 0) {
          filtersData.branch_id_list = branchIdList
        }

        this.$store.dispatch('distributionChannelChartData', filtersData)
      },
      onInputStartDate () {
        this.$refs.distributionChannelStatisticsStartDateMenu.save(this.distributionChannelStatistics.startDate)
        this.distributionChannelStatistics.startDateFormatted = this.formatDate(this.distributionChannelStatistics.startDate)
        this.getDistributionChannelChartData()
      },
      onInputEndDate () {
        this.$refs.distributionChannelStatisticsEndDateMenu.save(this.distributionChannelStatistics.endDate)
        this.distributionChannelStatistics.endDateFormatted = this.formatDate(this.distributionChannelStatistics.endDate)
        this.getDistributionChannelChartData()
      },
      onBranchInput () {
        this.distributionChannelStatistics.branchesSelected = []
        for (let i = 0; i < this.distributionChannelStatistics.branches.length; i++) {
          if (this.distributionChannelStatistics.branches[i].checked) {
            this.distributionChannelStatistics.branchesSelected.push(this.distributionChannelStatistics.branches[i].title)
          }
        }
        this.getDistributionChannelChartData()
      },
      productItemsUpdate () {
        this.distributionChannelStatistics.productItems = []
        this.distributionChannelStatistics.productCategoryIdList = []
        let tree = this.$refs.distributionChannelStatisticsTree.model
        for (let i = 0; i < tree.length; i++) {
          if (tree[i].states.checked) {
            this.distributionChannelStatistics.productItems.push({title: tree[i].data.text, color: 'blue lighten-3', id: tree[i].data.id, type: tree[i].data.type})
            this.distributionChannelStatistics.productCategoryIdList.push(tree[i].data.id)
          } else {
            for (let k = 0; k < tree[i].children.length; k++) {
              if (tree[i].children[k].states.checked) {
                this.distributionChannelStatistics.productItems.push({title: tree[i].children[k].data.text, color: 'green lighten-3', id: tree[i].children[k].data.id, type: tree[i].children[k].data.type})
                this.distributionChannelStatistics.productBrandIdList.push(tree[i].children[k].data.id)
              } else {
                for (let j = 0; j < tree[i].children[k].children.length; j++) {
                  if (tree[i].children[k].children[j].states.checked) {
                    this.distributionChannelStatistics.productItems.push({title: tree[i].children[k].children[j].data.text, color: 'orange lighten-3', id: tree[i].children[k].children[j].data.id, type: tree[i].children[k].children[j].data.type})
                    this.distributionChannelStatistics.productSkuList.push(tree[i].children[k].children[j].data.id)
                  }
                }
              }
            }
          }
        }
      },
      async getProductCategory () {
        let categoryList = []
        await this.$store.dispatch('getProductCategoryList')
          .then((data) => {
            for (let i = 0; i < data.product_category_list.length; i++) {
              categoryList[i] = {
                text: data.product_category_list[i].title,
                data: {
                  id: data.product_category_list[i].id,
                  type: 'category'
                },
                id: this.productTreeIdCounter++,
                isBatch: true
              }
              categoryList[i].state = { checkbox: true }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return categoryList
      },
      async getProductBrand (categoryId) {
        let brandList = []
        await this.$store.dispatch('getProductBrandList', {id: categoryId})
          .then((data) => {
            for (let i = 0; i < data.product_category_brand_list.length; i++) {
              brandList[i] = {
                text: data.product_category_brand_list[i].title,
                data: {
                  id: data.product_category_brand_list[i].id,
                  productBrandId: data.product_category_brand_list[i].product_brand_id,
                  type: 'brand'
                },
                id: this.productTreeIdCounter++,
                isBatch: true
              }
              brandList[i].state = { checkbox: true }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return brandList
      },
      async getProductSku (brandId) {
        let skuList = []
        await this.$store.dispatch('getProductSkuList', {id: brandId})
          .then((data) => {
            for (let i = 0; i < data.product_sku_list.length; i++) {
              skuList[i] = {
                text: data.product_sku_list[i].title,
                data: {
                  id: data.product_sku_list[i].id,
                  type: 'sku'
                },
                id: this.productTreeIdCounter++,
                isBatch: false
              }

              skuList[i].state = { checkbox: true }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return skuList
      },
      filterChildrenProductIdList (tree, statisticsObj) {
        for (let i = 0; i < tree.length; i++) {
          let brandDelete = false
          let categoryPosition = statisticsObj.productCategoryIdList.indexOf(tree[i].data.id)
          if (~categoryPosition) {
            brandDelete = true
          }
          for (let j = 0; j < tree[i].children.length; j++) {
            let skuDelete = false
            let brandPosition = statisticsObj.productBrandIdList.indexOf(tree[i].children[j].data.id)
            if (~brandPosition) {
              skuDelete = true
            }
            for (let k = 0; k < tree[i].children[j].children.length; k++) {
              let skuPosition = statisticsObj.productSkuList.indexOf(tree[i].children[j].children[k].data.id)
              if (skuDelete && ~skuPosition) {
                statisticsObj.productSkuList.splice(skuPosition, 1)
              }
            }
            if (brandDelete && ~brandPosition) {
              statisticsObj.productBrandIdList.splice(brandPosition, 1)
            }
          }
        }
      }
    },
    watch: {
      distributionChannelChartData (val) {
        this.distributionChannelStatistics.chartData = []
        for (let k = 0; k < this.distributionChannelChartData.length; k++) {
          let index = this.distributionChannelStatistics.chartData.length
          this.distributionChannelStatistics.chartData[index] = {data: {}, name: this.distributionChannelChartData[k].title}
          for (let i = 0; i < this.distributionChannelChartData[k].chart_series_value_list.length; i++) {
            this.distributionChannelStatistics.chartData[index].data[this.distributionChannelChartData[k].chart_series_value_list[i].date] = this.distributionChannelChartData[k].chart_series_value_list[i].value
          }
        }
      },
      distributionChannelStatisticsProductDialog (val) {
        if (!this.distributionChannelStatistics.productDialog) {
          this.getDistributionChannelChartData()
        }
      },
      branchList (val) {
        this.distributionChannelStatistics.branches = this.branchList
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Statistics/StatisticsDistributionChannel.vue